import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'constantPretty'
})
export class ConstantPrettyPipe implements PipeTransform {

  transform(value: string | undefined, _args?: never): string | undefined {
    if (value) {
      const prettyValue: string = value.split('_').join(' ').toLowerCase();
      return prettyValue.substring(0, 1).toUpperCase() + prettyValue.substring(1);
    } else {
      return value;
    }
  }

}
